import React from 'react';
import { getRegisteredStepByType, getSelectedStepDetailsById } from '@utils';
import { FormSection } from '@components/FormSection/FormSection';
import { hasValue, Input } from 'uxp/components';
import { updateStep } from './StepConfigUtils';
import './StepConfigurator.scss';
const StepRenderer = props => {
    var _a;
    return React.createElement(React.Fragment, null, (_a = props.step) === null || _a === void 0 ? void 0 : _a.render(props.context, props.query, props.onChange, props.id));
};
export const StepConfigurator = props => {
    const { query, onChange, selectedStepId, context } = props;
    const { step } = getSelectedStepDetailsById(query, selectedStepId);
    function updateName(name) {
        const _query = updateStep(query, selectedStepId, 'name', name);
        onChange(_query);
    }
    const $L = (key) => context.uxpContext.$L(key);
    function renderNameField() {
        return React.createElement(FormSection, { label: $L('lqe.common.name'), error: !hasValue(step === null || step === void 0 ? void 0 : step.name) ? $L('lqe.sc.name-required') : null },
            React.createElement(Input, { value: (step === null || step === void 0 ? void 0 : step.name) || '', onChange: s => updateName(s) }));
    }
    const registeredStep = getRegisteredStepByType(step === null || step === void 0 ? void 0 : step.type);
    function renderStep() {
        if (!registeredStep)
            return null;
        return React.createElement(StepRenderer, { key: registeredStep.type, step: registeredStep, context: context, query: query, onChange: onChange, id: selectedStepId });
    }
    if (!registeredStep)
        return null;
    return React.createElement("div", { className: "lqe-sc-2be4c092" },
        React.createElement("div", { className: "lqe-sc__desc-2be4c092" }, (registeredStep === null || registeredStep === void 0 ? void 0 : registeredStep.description) ? $L(registeredStep.description) : ''),
        renderNameField(),
        renderStep());
};
